import React, { useEffect } from 'react';
import { useIdleTimerContext } from '../contexts/IdleTimerContext';

/**
 * Higher-Order Component (HOC) that adds idle timer reset functionality to components
 * Resets the idle timer when the component mounts
 * @param Component The component to wrap
 * @returns The wrapped component with idle timer functionality
 */
export function withIdleTimer<P extends object>(Component: React.ComponentType<P>): React.FC<P> {
  const WithIdleTimer: React.FC<P> = (props) => {
    const { resetTimer } = useIdleTimerContext();

    // Reset timer on component mount
    useEffect(() => {
      console.debug('withIdleTimer: Component mounted, resetting timer');
      resetTimer();
    }, [resetTimer]);

    return <Component {...props} />;
  };

  // Set display name for debugging
  const displayName = Component.displayName || Component.name || 'Component';
  WithIdleTimer.displayName = `WithIdleTimer(${displayName})`;

  return WithIdleTimer;
}

export default withIdleTimer; 